// React
import React, { useEffect } from "react";
// Assets
import DigiVerticalLogo from "../assets/img/DigiVerticalWhiteLogo.png";
const URLS_TO_BE_REDIRECTED_FROM = [
    "https://admin-iam.digiventures.la",
    "https://backoffice.digiventures.la",
];
const FullscreenLoader = () => {
    useEffect(() => {
        if (URLS_TO_BE_REDIRECTED_FROM.includes(window.location.origin)) {
            const { pathname, search } = window.location;
            window.location.replace(
                `https://admin.digiventures.la${pathname}${search}`
            );
        }
    }, []);

    return (
        <div className="loading-app">
            <img src={DigiVerticalLogo} className="login-logo" />
            <div className="circle-loader" />
        </div>
    );
};

export default FullscreenLoader;
